module.exports = __webpack_public_path__ + "img/overview.3059a39c.png";